// extracted by mini-css-extract-plugin
export default {"sameGateway":"SmeUsage_sameGateway__xzwhz"};